import { useEffect, useMemo } from 'react';
import { useRecoilState } from 'recoil';
// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import { SITE_SKYPASS, SITE_KOREANAIR_SAVINGS } from '@ecp/common/src/const/site/siteNumberConst';

import { recommendBrandListState } from '@mo-recoil/brand/atom';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import brandApi from '@mo-apis/good/brandApi';

const useRecommendBrandList = () => {
  const [recommendBrandList, setRecommendBrandList] = useRecoilState(recommendBrandListState);
  const { siteNumber } = useSiteInfo();
  // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
  const isSkypass = useMemo(() => siteNumber === SITE_SKYPASS || siteNumber === SITE_KOREANAIR_SAVINGS, [siteNumber]);

  useEffect(() => {
    (async () => {
      if (recommendBrandList.length === 0 && !isSkypass) {
        const { result } = await brandApi.getRecommendationBrandList();
        setRecommendBrandList(result || []);
      }
    })();
  }, [recommendBrandList.length, setRecommendBrandList]);
  return recommendBrandList;
};
export default useRecommendBrandList;

